module.exports = __webpack_public_path__ + "img/features_privacymaster_phone_mobile2.df674fa3.jpg";